module.exports = __webpack_public_path__ + "static/media/LovingDoodle.acd1caee.png";